{
  "enum": {
    "IxcCorpactionsCadataV1SourceBucket": {
      "DTC": "DTC",
      "ICE": "ICE",
      "UNSPECIFIED": "Unspecified"
    }
  }
}